var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"aside",class:{ asideOpen: _vm.mobileMenuActive }},[_vm._m(0),_c('TheMenu')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand"},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("../assets/image/logo.png"),"alt":"logo"}})])])
}]

export { render, staticRenderFns }